/* All my Blue — pieces showcase
   The section is (N+1) screens tall; a sticky stage pins while the pieces
   travel sideways as 3D boxes, one at a time. Progress comes from scroll.
   Each piece fills the space between the counter and the name: it shrinks when
   the window is short and can grow up to 1.3x its set width on tall screens.
   Only the button of the piece on screen shows (bottom right).
   Reduced motion: the stage unpins and the pieces stack (CSS .is-static). */
(function () {
  /* On desktop Horizon scrolls .page-wrapper, on phones the window scrolls */
  function scroller(el) {
    var n = el.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
      n = n.parentElement;
    }
    return null;
  }

  function init(show) {
    if (show.getAttribute('data-ready')) return;
    show.setAttribute('data-ready', '1');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pcs = Array.prototype.slice.call(show.querySelectorAll('.amb-show__piece'));
    var infos = Array.prototype.slice.call(show.querySelectorAll('.amb-show__info'));
    var ctas = Array.prototype.slice.call(show.querySelectorAll('.amb-show__cta'));
    var stage = show.querySelector('.amb-show__stage');
    var count = show.querySelector('[data-show-count]');
    var bar = show.querySelector('[data-show-bar]');
    var N = pcs.length;
    if (!N) return;
    if (reduce) {
      show.classList.add('is-static');
      infos.forEach(function (el) { el.classList.add('is-on'); });
      pcs.forEach(function (el) { el.classList.add('is-on'); });
      return;
    }
    var mx = 0, my = 0, t0 = performance.now(), p = 0;
    function vh() { return Math.min(window.innerHeight || 900, 900); }
    function setVh() { show.style.setProperty('--vh', vh() + 'px'); }
    setVh();
    window.addEventListener('resize', setVh);

    function layout(now) {
      var r = show.getBoundingClientRect();
      var h = vh();
      var onScreen = r.bottom > 0 && r.top < h;
      if (onScreen) {
        p = Math.max(0, Math.min(N - 1, (-r.top) / h));
        var sway = Math.sin((now - t0) / 1600) * 4;
        var W = show.clientWidth || 1280;
        var SH = stage ? stage.clientHeight : h * 0.6;
        var SW = stage ? stage.clientWidth : W * 0.9;
        pcs.forEach(function (el, k) {
          var d = p - k, a = Math.abs(d);
          if (a > 1.15) { el.style.opacity = 0; el.style.transform = 'translateX(' + (d < 0 ? 1 : -1) * W + 'px)'; return; }
          /* room for the box depth and the slight tilt: 32px vertical, 8px each side */
          var fit = Math.min(1.3, (SH - 32) / el.offsetHeight, (SW - 16) / el.offsetWidth);
          var active = a < 0.5 ? (1 - a * 2) : 0;
          var ry = d * -62 + sway * active + mx * 14 * active;
          var rx = my * -8 * active;
          el.style.opacity = 1 - Math.min(a, 1) * 0.55;
          el.style.transform = 'translate3d(' + (d * -(W * 0.82)) + 'px,0,' + (-a * 320) + 'px) rotateY(' + ry + 'deg) rotateX(' + rx + 'deg) scale(' + ((1 - a * 0.12) * Math.max(fit, 0.3)).toFixed(4) + ')';
        });
        var idx = Math.round(p);
        /* only the piece on screen takes clicks on its photo */
        pcs.forEach(function (el, k) { el.classList.toggle('is-on', k === idx); });
        infos.forEach(function (el, k) { el.classList.toggle('is-on', k === idx); });
        ctas.forEach(function (el) { el.classList.toggle('is-on', +el.getAttribute('data-k') === idx); });
        if (count) count.textContent = ('0' + (idx + 1)).slice(-2);
        if (bar) bar.style.width = (N > 1 ? (p / (N - 1)) * 100 : 100) + '%';
      }
      requestAnimationFrame(layout);
    }
    requestAnimationFrame(layout);

    if (window.matchMedia('(hover: hover)').matches) {
      show.addEventListener('mousemove', function (e) {
        var r = show.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;
        my = (e.clientY - Math.max(r.top, 0)) / vh() - 0.5;
      });
      show.addEventListener('mouseleave', function () { mx = 0; my = 0; });
    }
    show.querySelectorAll('[data-show]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = Math.round(p) + (b.getAttribute('data-show') === 'next' ? 1 : -1);
        k = Math.max(0, Math.min(N - 1, k));
        var off = show.getBoundingClientRect().top + k * vh();
        var sc = scroller(show);
        if (sc) sc.scrollTo({ top: sc.scrollTop + off - sc.getBoundingClientRect().top, behavior: 'smooth' });
        else window.scrollTo({ top: (window.scrollY || window.pageYOffset || 0) + off, behavior: 'smooth' });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-amb-show]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
